import { render, staticRenderFns } from "./GiftExpress_detail.vue?vue&type=template&id=4aa8cce4&scoped=true"
import script from "./GiftExpress_detail.vue?vue&type=script&lang=js"
export * from "./GiftExpress_detail.vue?vue&type=script&lang=js"
import style0 from "./GiftExpress_detail.vue?vue&type=style&index=0&id=4aa8cce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8cce4",
  null
  
)

export default component.exports